// extracted by mini-css-extract-plugin
export default {"Container":"ppt_Container__j-jZ3","backdrop":"ppt_backdrop__XXPpx"};